/**
 * TextLoader - A loading component for home page card sections
 *
 * Displays a card-style loading skeleton with a title and animated pulse placeholders.
 * Used specifically for home page components that need a consistent loading state.
 */
export const TextLoader = ({
  title,
  className = "",
}: {
  title: string;
  className?: string;
}) => {
  return (
    <div className={`flex flex-col h-full ${className}`}>
      <h2 className="text-lg font-medium mb-4">{title}</h2>
      <div className="bg-white rounded-lg border border-gray-200 shadow flex-1">
        <div className="p-4">
          <div className="flex flex-col gap-2">
            <div className="h-4 w-32 bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-48 bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-40 bg-gray-200 rounded animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * LastDeployLoader - Loading skeleton for the Last Deploy widget.
 * Matches the loaded layout and spacing: one content line, divider, then another content line.
 */
export const LastDeployLoader = () => {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-lg font-medium mb-4">Last Deploy</h2>
      <div className="bg-white rounded-lg border border-gray-200 shadow flex-1">
        <div className="p-4">
          <div className="flex flex-col gap-2">
            <div className="h-6 w-full bg-gray-200 rounded animate-pulse" />
            <div className="h-px bg-gray-200 my-2" />
            <div className="h-6 w-full bg-gray-200 rounded animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
};
